//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import Chatbox from '../components/messenger/chatbox';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import DJAreaSideMenu from './sidemenu';

import VideoPlayer from '../components/video/video2';
import CopyBox from '../components/bbcode/copy-box';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

function Connection({user, shoutcast, live, next, video}) {

	video.video.videorate = parseInt(video.video.videorate);
	let bitlow = Math.round(((video.video.width * video.video.height) / 1000 * video.video.fps * 0.1)/500)*500;
	let bithigh = Math.round(((video.video.width * video.video.height) / 1000 * video.video.fps * 0.15)/500)*500;

	try{
		return (
			<>
				<div className="live_videorate">
					<div className="row">
						<div className="col text-center ms-3 me-1 py-2" style={{backgroundColor: (video.width>1928||video.height>1088)?'#AA0000':'#1CAC78'}}>
							<span className="live_title1">Resolution</span><br />
							<span className="live_title2">
								{video.video.width > 0 ?
									<>
										{(video.video.width>1928||video.video.height>1088)?
											<><span style={{color:'#00ff00'}}><FontAwesomeIcon icon="down-long" className="" /></span> {video.video.width}x{video.video.height}</>
										:
											<><span style={{color:'#00ff00'}}>&#10004;</span> {video.video.width}x{video.video.height}</>
										}
									</>
								:
									<>Waiting ...</>
								}
							</span><br />
							<span className="live_title3">Maximum: 1920x1080</span>
						</div>
						<div className="col text-center mx-1 py-2" style={{backgroundColor: (video.video.fps>30?'#AA0000':'#1CAC78')}}>
							<span className="live_title1">FPS</span><br />
							<span className="live_title2">
								{video.video.width > 0 ?
									<>
										{video.video.fps>30?
											<><span style={{color:'#00ff00'}}><FontAwesomeIcon icon="down-long" className="" /></span> {video.video.fps} FPS</>
										:
											<><span style={{color:'#00ff00'}}>&#10004;</span> {video.video.fps} FPS</>
										}
									</>
								:
									<>Waiting ...</>
								}
							</span><br />
							<span className="live_title3">Maximum: 30 FPS</span>
						</div>
						<div className="col text-center mx-1 py-2" style={{backgroundColor: (video.video.videorate<bitlow||video.video.videorate>bithigh?'#AA0000':'#1CAC78')}}>
							<span className="live_title1">Video Bitrate</span><br />
							<span className="live_title2">
								{video.video.width > 0 ?
									<>
										{video.video.videorate < bitlow &&
											<><span style={{color:'#00ff00'}}><FontAwesomeIcon icon="up-long" className="" /></span> {video.video.videorate} kbps</>
										}
										{video.video.videorate > bithigh &&
											<><span style={{color:'#00ff00'}}><FontAwesomeIcon icon="down-long" className="" /></span> {video.video.videorate} kbps</>
										}
										{(video.video.videorate >= bitlow && video.video.videorate<=bithigh) &&
											<><span style={{color:'#00ff00'}}>&#10004;</span> {video.video.videorate} kbps</>
										}
										
									</>
								:
									<>Waiting ...</>
								}
							</span><br />
							<span className="live_title3">
								{video.video.width > 0 && <>{bitlow}-{bithigh} kbps</>}
							</span>
						</div>
						<div className="col text-center mx-1 py-2" style={{backgroundColor: (video.audiorate>0&&video.audiorate<320?'#AA0000':'#1CAC78')}}>
							<span className="live_title1">Audio Bitrate</span><br />
							<span className="live_title2">
								{video.video.width > 0 ?
									<>
										{video.video.audiorate<320?
											<><span style={{color:'#00ff00'}}><FontAwesomeIcon icon="up-long" className="" /></span> {video.video.audiorate} kbps</>
										:
											<><span style={{color:'#00ff00'}}>&#10004;</span> {video.video.audiorate} kbps</>
										}
									</>
								:
									<>Waiting ...</>
								}
							</span><br />
							<span className="live_title3">Minimum: 320 kbps</span>
						</div>

						<div className="col text-center ms-1 me-3 py-2" style={{backgroundColor: ((video.audio.max_level<=-12 || video.audio.max_level>=0)?'#AA0000':'#1CAC78')}}>
							<span className="live_title1">Audio Levels</span><br />
							<span className="live_title2">
							{video.audio.max_level === -100 ?
								<>
									Please wait
								</>
							:
								<>
									{video.audio.max_level} DB
								</>
							}</span><br />
							<span className="live_title3">
									{(video.audio.max_level<=-12 || video.audio.max_level>=0)?
										<><span style={{color:'#00ff00'}}>&#10060;</span> -12.0 to -1.0 DB</>
									:
										<><span style={{color:'#00ff00'}}>&#10004;</span> -12.0 to -1.0 DB</>
									}
								</span>
							</div>
						
					</div>
				</div>
			</>
		)
	} catch(error) { console.log(error); }
}

export default class DJAreaTest extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			mode: 0,
      icecast: {},
			rtmp: {},

			/*
			
			source: 'https://cloud.mix365.co.uk:4434/test/mix365radio/index.m3u8',
			shoutcast: {connected_butt: false, connected_obs: false, connected_rtmp: false, connected_azura: false, dj: '', artist: '', title: '',},
			videobitrate: {connected_rtmp: false, connected_test: false, path: '', width: 0, height: 0, fps: 0, videorate: 0, audiorate: 0},
			*/

			select: {
				select: 3,
			},
			meta: {
				azura: {connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0},
				rtmp: {connected: 0, path: this.channel, width: 0, height: 0, fps: 0, videorate: 0, audiorate: 0, time: 0, listeners: 0},
				video: { width: 0, height: 0, fps: 0, videorate: 0, audiorate: 0, samplerate: 0 },
				audio: { mean_level: -100, max_level: -100, no_tries: 0, time: 0 }
			},

			resetvideo: false,
			//HeaderShoutcast: null,
			//VideoRate: null,

			ChatLiveVideo: null,
			ChatMeta: null,
		};
		this.getMode = this.getMode.bind(this);
		this.onReady = this.onReady.bind(this);
		this.onError = this.onError.bind(this);
		this.reloadPlayer = this.reloadPlayer.bind(this);
  };

  async componentDidMount() {
		document.title = "Admin - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

		await this.getMode(null);

		//EventEmitter.emit('/header/shoutcast/request', {});

		/*const HeaderShoutcast = EventEmitter.addListener('/header/shoutcast', async data => {
			//this.renderLiveFeed( data );
			//this.setState({shoutcast: data.cast});
		}); this.setState({HeaderShoutcast});*/

		//---- VideoRate
		/*const VideoRate = EventEmitter.addListener('/chatlive/videorate', async data => {
			this.setState({videobitrate: data});
		}); this.setState({VideoRate});*/

		//---- Video handler
		const ChatLiveVideo = EventEmitter.addListener(`/channel/channel`, async data => {
			//console.log(data);
			if( data.channel === 'technical' ) this.setState({select: data.Live, meta: data.Meta});
		}); this.setState({ChatLiveVideo});

		const ChatMeta = EventEmitter.addListener(`/channel/meta`, async data => {
			//console.log(data);
			//this.setState({meta: data});
		}); this.setState({ChatMeta});



	}

	componentWillUnmount() {
		//if( this.state.HeaderShoutcast ) this.state.HeaderShoutcast.remove();
		//if( this.state.VideoRate ) this.state.VideoRate.remove();
		if( this.state.ChatLiveVideo ) this.state.ChatLiveVideo.remove();
		if( this.state.ChatMeta ) this.state.ChatMeta.remove();
	}

	async getMode(mode) {
		var params = new URLSearchParams();
		if( mode !== null ) params.append('mode', mode);
		const x = await postApi('/api/v2/djarea/test', params);
		//console.log(x.data);
		this.setState({mode: x.data.mode, icecast: x.data.icecast, rtmp: x.data.rtmp, meta: x.data.Meta, select: x.data.Live});
		return;
	}

	onReady(event) {
		const player = window.jwplayer(this.playerId);
		player.play();
	}

	onError(event) {
		//console.log("here!");
		/*let x = this.state.videobitrate;
		x.connected_test = false;
		this.setState({videobitrate: x}, () => {
			x.connected_test = true;
			this.setState({videobitrate: x});
		})*/
	}

	reloadPlayer() {
		if( this.state.resetvideo ) return;
		this.setState({resetvideo: true}, ()=>{
			setTimeout(()=>{
				if( this.state.videobitrate.select===3 ) return;
				let select = this.state.videobitrate;
				select.connected_test = false;
				this.setState({videobitrate: select, resetvideo: false}, ()=> {
					select.connected_test = true;
					this.setState({videobitrate: select,});
				});
			},4000);
		});
	}

	render() {
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>
					{this.state.mode===1&&
						<Row>
							<Col xs={12} className="text-center pb-4">
								<ButtonGroup size="sm">
									<Button><span style={{color:'#00ff00'}}>&#10004;</span> Audio Test</Button>
									<Button onClick={()=>{this.getMode(2)}}>Video Test</Button>
								</ButtonGroup>
							</Col>
							<Col>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Icecast / Audio Testing</h3>
									</div>
									<div className="card-body">
										<Row>
											<Col md={3}>
												To Connect to our Icecast testing server:<br /><br />
												
												Icecast 2 Address:<br />
												<CopyBox content={this.state.icecast.address} />
												
												Port:<br />
												<CopyBox content={this.state.icecast.port} />

												Username:<br />
												<CopyBox content={this.state.icecast.username} />

												Password:<br />
												<CopyBox content={this.state.icecast.password} />

												Mount Point:<br />
												<CopyBox content={this.state.icecast.mount} />

												Audio Bitrate:<br />
												<CopyBox content={this.state.icecast.rate+' kbps'} />

												</Col>
											<Col>
												<iframe src="https://cloud.mix365.co.uk:4435/public/silence" width="100%" height="300" title="Audio Testing" />
											</Col>
											<Col style={{height:550}}>
												<Chatbox
													type='technical'
													colour={'#8c52ff'}
													newColour={''}
													theatre={false}
													mchat={false}
												/>
											</Col>
										</Row>
									</div>
								</div>
							</Col>
						</Row>
					}
					{this.state.mode===2&&
						<Row>
							<Col xs={12} className="text-center pb-4">
								<ButtonGroup size="sm">
									<Button onClick={()=>{this.getMode(1)}}>Audio Test</Button>
									<Button><span style={{color:'#00ff00'}}>&#10004;</span> Video Test</Button>
								</ButtonGroup>
							</Col>
							<Col>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">OBS / Video Testing</h3>
									</div>
									<div className="card-body">
										<Row>
											<Col md={3}>
												To Connect to our RTMP test server:<br /><br />
												Europe Server address:<br />
												<CopyBox content={this.state.rtmp.address} />
												
												Non Europe Server address:<br />
												<CopyBox content={this.state.rtmp.address_cdn} />
												
												Stream key:<br />
												<CopyBox content={this.state.rtmp.streamkey} />
											</Col>
											<Col>
											{this.state.select.select === 1 ?
												<>
													<VideoPlayer
														id="video"
														url={'test'}
														select={1}
														uid={0}
														//theatre={this.theatre}
														onError={this.onError}
														height={this.state.meta.video.height}
													/>
												</>
											:
												<>
													Test video will appear here.
												</>
											}
											</Col>
											<Col style={{height:500}}>
												<Chatbox
													type='technical'
													colour={'#8c52ff'}
													newColour={''}
													theatre={false}
													mchat={false}
												/>
											</Col>
										</Row>
									</div>
									<div className="card-footer">
										<Connection shoutcast={this.state.shoutcast} video={this.state.meta} />
									</div>
								</div>
							</Col>
						</Row>
					}
				</Col>
			</Row>
		);
	}
}
